// extracted by mini-css-extract-plugin
module.exports = {"wrap":"home_wrap__1XfZB"};